import { NavLink } from "react-router-dom";
import { Compass, Search, CalendarDays, Bookmark } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useSaved } from "../hooks/useSaved";
import { supabase } from "../lib/supabaseClient";

const items = [
  { to: "/", label: "Discover", icon: Compass, testid: "nav-discover", end: true },
  { to: "/search", label: "Search", icon: Search, testid: "nav-search" },
  { to: "/calendar", label: "Calendar", icon: CalendarDays, testid: "nav-calendar" },
  { to: "/saved", label: "Saved", icon: Bookmark, testid: "nav-saved" },
];

export const BottomNav = () => {
  const { saved } = useSaved();
  // Same eligibility as the Saved page: public_events, status active, not ended.
  const [eligible, setEligible] = useState(() => new Set());
  const checked = useRef(new Set());

  useEffect(() => {
    const missing = saved.filter((id) => !checked.current.has(id));
    if (!missing.length) return;
    missing.forEach((id) => checked.current.add(id));
    supabase
      .from("public_events")
      .select("id")
      .in("id", missing)
      .eq("status", "active")
      .gt("end_at", new Date().toISOString())
      .then(({ data, error }) => {
        if (error) { missing.forEach((id) => checked.current.delete(id)); return; }
        if (data?.length) setEligible((prev) => new Set([...prev, ...data.map((r) => r.id)]));
      });
  }, [saved]);

  const badgeCount = saved.filter((id) => eligible.has(id)).length;

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#050505]"
    >
      <div className="mx-auto flex max-w-md items-center justify-around px-6 pb-6 md:max-lg:pb-3 pt-3">
        {items.map(({ to, label, icon: Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className="flex flex-col items-center gap-1"
          >
            {({ isActive }) => (
              <>
                <div className="relative">
                  <Icon
                    className={`h-6 w-6 transition-colors duration-200 ${
                      isActive ? "text-[#ff2a00]" : "text-white/45"
                    }`}
                    strokeWidth={isActive ? 2.4 : 2}
                  />
                  {label === "Saved" && badgeCount > 0 && (
                    <span className="absolute -right-2 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-[#ff2a00] px-1 text-[10px] font-bold text-white">
                      {badgeCount}
                    </span>
                  )}
                </div>
                <span
                  className={`text-[10px] font-semibold tracking-wide transition-colors duration-200 ${
                    isActive ? "text-white" : "text-white/40"
                  }`}
                >
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
